import ImageLoader from '../../ImageLoader';

interface IAdvertisingChannelProps {
  src: string;
  width: string;
  height: string;
}

function AdvertisingChannel({ src, width, height }: IAdvertisingChannelProps) {
  return (
    <div className="img-slider" style={{ cursor: 'default' }}>
      <ImageLoader src={src} width={width} height={height} />
    </div>
  );
}

export default AdvertisingChannel;
